module.exports = __webpack_public_path__ + "static/media/icon_formulations.281d20c0.svg";